module.exports = __webpack_public_path__ + "img/75.45eab5f1.png";